<template>
	<vs-popup autoFocus scrollable title="Nieuwe Voorraad Pool aanmaken" :active.sync="isOpen">
		<div class="vx-row">
			<div class="vx-col w-full mb-5">
				<vs-input
					label="Pool naam"
					v-model="form.name"
				></vs-input>
			</div>

			<div class="vx-col w-full mb-5">
				<vs-input
					label="Beschrijving (optioneel)"
					v-model="form.description"
					type="textarea"
				></vs-input>
			</div>

			<div class="vx-col w-full sm:w-1/2 mb-5">
				<vs-input
					label="Centrale voorraad"
					v-model.number="form.central_stock"
					type="number"
				></vs-input>
			</div>

			<div class="vx-col w-full sm:w-1/2 mb-5">
				<vs-input
					label="Veiligheidsvoorraad"
					v-model.number="form.safety_stock"
					type="number"
				></vs-input>
			</div>
		</div>

		<div class="vx-row">
			<div class="vx-col w-full">
				<div class="flex justify-end mt-3">
					<vs-button @click="closeDialog" color="danger" class="mr-2">Annuleren</vs-button>
					<vs-button @click="savePool" color="primary" type="filled" :loading="isSaving">Aanmaken</vs-button>
				</div>
			</div>
		</div>
	</vs-popup>
</template>

<script>


export default {
	name: 'createPool',
	props: {
		open: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			isOpen: false,
			isSaving: false,
			form: {
				name: '',
				description: '',
				central_stock: 0,
				safety_stock: 0
			}
		}
	},
	watch: {
		open(newVal) {
			this.isOpen = newVal;
		},
		isOpen(newVal) {
			if (!newVal) {
				this.resetForm();
			}
		}
	},
	methods: {
		async savePool() {
			this.isSaving = true;
			try {
				await this.$store.dispatch('poolsData/createPool', {
					name: this.form.name,
					description: this.form.description,
					central_stock: this.form.central_stock,
					safety_stock: this.form.safety_stock
				});

				this.$vs.notify({
					title: 'Gelukt',
					text: 'Pool is aangemaakt',
					color: 'success'
				});

				this.$emit('close');
				this.closeDialog();
			} catch (error) {
				this.$vs.notify({
					title: 'Oops',
					text: 'Pool kon niet worden aangemaakt',
					color: 'danger'
				});
			} finally {
				this.isSaving = false;
			}
		},

		closeDialog() {
			this.isOpen = false;
			this.$emit('close');
		},

		resetForm() {
			this.form = {
				name: '',
				description: '',
				central_stock: 0,
				safety_stock: 0
			};
		}
	}
}
</script>

<style scoped>
.create-pool-dialog {
	max-width: 600px;
}
</style>
